import React from 'react';
import { View, Text } from 'react-native';
import { useThemeColors } from '@/lib/useThemeColors';

interface SectionHeaderProps {
  label: string;
  trailing?: React.ReactNode;
}

export function SectionHeader({ label, trailing }: SectionHeaderProps) {
  const colors = useThemeColors();
  return (
    <View
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        gap: 10,
        marginBottom: 10,
      }}
    >
      <Text
        style={{
          color: colors.text.tertiary,
          fontSize: 9,
          fontWeight: '700',
          letterSpacing: 1,
          textTransform: 'uppercase',
          flexShrink: 0,
        }}
        numberOfLines={1}
      >
        {label}
      </Text>
      <View
        style={{
          flex: 1,
          height: 1,
          backgroundColor: colors.border.light,
        }}
      />
      {trailing}
    </View>
  );
}
